import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './lang/en/en.json';
import sr from './lang/sr/sr.json';

// proveri da li postoji jezik u localStorage
const savedLanguage = localStorage.getItem('language') || 'sr';

i18n
    .use(initReactI18next)
    .init({
        interpolation: { escapeValue: false },
        lng: savedLanguage, // koristi ono što je korisnik ranije izabrao
        resources: {
            en: { global: en },
            sr: { global: sr },
        },
    });

export default i18n;
